import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoreCurrencyQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StoreCurrencyQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, currency?: Types.Currency | null, currency_symbol?: string | null } | null };


export const StoreCurrencyDocument = gql`
    query storeCurrency($id: ID!) {
  store(id: $id) {
    id
    currency
    currency_symbol
  }
}
    `;

/**
 * __useStoreCurrencyQuery__
 *
 * To run a query within a React component, call `useStoreCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreCurrencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStoreCurrencyQuery(baseOptions: Apollo.QueryHookOptions<StoreCurrencyQuery, StoreCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreCurrencyQuery, StoreCurrencyQueryVariables>(StoreCurrencyDocument, options);
      }
export function useStoreCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreCurrencyQuery, StoreCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreCurrencyQuery, StoreCurrencyQueryVariables>(StoreCurrencyDocument, options);
        }
export type StoreCurrencyQueryHookResult = ReturnType<typeof useStoreCurrencyQuery>;
export type StoreCurrencyLazyQueryHookResult = ReturnType<typeof useStoreCurrencyLazyQuery>;
export type StoreCurrencyQueryResult = Apollo.QueryResult<StoreCurrencyQuery, StoreCurrencyQueryVariables>;